/* src/app/components/payee-sectors/payee-sectors.component.css */
/*# sourceMappingURL=payee-sectors.component.css.map */
